import React from 'react';

export default function Invalid({ message }) {
  return (
    <div style={{
      height:'100vh', display:'flex', flexDirection:'column',
      alignItems:'center', justifyContent:'center',
      background:'#0a0a0a', padding:32, textAlign:'center',
      fontFamily:'system-ui',
    }}>
      <div style={{ fontSize:40, marginBottom:16 }}>⚠️</div>
      <div style={{ fontSize:20, fontWeight:600, color:'#fff', marginBottom:12 }}>
        Invalid Assessment Link
      </div>
      <div style={{ fontSize:14, color:'#666', maxWidth:320, lineHeight:1.6 }}>
        {message || 'This link is invalid or has already been used. Please contact your broker for a new link.'}
      </div>
    </div>
  );
}
